import { trans } from '@lingoda/i18n';
import {
    type ActivityChallengeParticipantStatusEnum,
    getApolloErrorUiMessage,
} from '@lingoda/monolith-graphql';
import { showErrorToast, showToast } from '@lingoda/toasts';
import { useJoinActivityChallenge } from '../../hooks';
import { ActiveChallengeWidgetUnjoinedLayout } from './ActiveChallengeWidgetUnjoinedLayout';

interface Props {
    challengeName: string;
    startDate: string;
    endDate: string;
    publicName: string;
    participants: number;
    userStatus: ActivityChallengeParticipantStatusEnum | undefined;
    challengeIconUrl: string | undefined;
}

export const ActiveChallengeWidgetUnjoined = (props: Props) => {
    const [joinChallenge, { loading }] = useJoinActivityChallenge({
        challengeName: props.challengeName,
        userStatus: props.userStatus,
        onSuccess() {
            showToast('success', trans('btn-challenge-joined', {}, 'student-challenges'));
        },
        onError(error) {
            showErrorToast(getApolloErrorUiMessage(error) || trans('masked-error', {}, 'errors'));
        },
    });

    const handleJoin = () => {
        void joinChallenge();
    };

    return (
        <ActiveChallengeWidgetUnjoinedLayout
            challengeName={props.challengeName}
            startDate={props.startDate}
            endDate={props.endDate}
            publicName={props.publicName}
            participants={props.participants}
            challengeIconUrl={props.challengeIconUrl}
            isJoining={loading}
            onJoin={handleJoin}
        />
    );
};
